// Paths list to update in the future
export const TV_PATHS = {
	MAIN: '/tv/strona-glowna',
	INTRODUCE_DECODER: '/tv/poznaj-dekoder-tv-smart',
	TELEVISION: '/tv/telewizja',
	CHANNELS: '/tv/kanaly',
	PROGRAM_DETAILS: '/tv/kanaly/szczegoly-programu/:id',
	EPG: '/tv/epg',
	RECORDINGS: '/tv/nagrania'
};
